export const dateToLetters = (dateStr) => {
    if (!dateStr) return '';

    // Evita saltos de zona horaria al parsear fechas "YYYY-MM-DD"
    const parts = dateStr.split(/[-T ]/);
    const d = new Date(parts[0], parseInt(parts[1]) - 1, parts[2]);

    const days = [
      "cero", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez",
      "once", "doce", "trece", "catorce", "quince", "dieciseis", "diecisiete", "dieciocho", "diecinueve",
      "veinte", "veintiuno", "veintidos", "veintitres", "veinticuatro", "veinticinco", "veintiseis",
      "veintisiete", "veintiocho", "veintinueve", "treinta", "treinta y uno"
    ];

    const months = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    // Mapa de años para cubrir el rango actual de créditos
    const years = {
      2024: "dos mil veinticuatro", 2025: "dos mil veinticinco", 2026: "dos mil veintiseis",
      2027: "dos mil veintisiete", 2028: "dos mil veintiocho", 2029: "dos mil veintinueve",
      2030: "dos mil treinta", 2031: "dos mil treinta y uno", 2032: "dos mil treinta y dos"
    };

    let dayWord = days[d.getDate()];
    if (d.getDate() === 1) dayWord = "primero";

    return `${dayWord} de ${months[d.getMonth()]}, del año ${years[d.getFullYear()] || d.getFullYear()}`;

};
